import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
export default {
    __name: 'ServiceTyp',
    props: {
        value: {
            type: Array,
            default: ()=>[]
        }
    },
    emits: [
        'update:servicesTyp'
    ],
    setup (__props, { emit: __emit }) {
        const store = useStore();
        let servicesTypList = computed(()=>{
            return store.state.filters.serviceTyp;
        });
        let servicesTyp = ref(__props.value);
        let width = window.innerWidth;
        const emit = __emit;
        const updateServiceTyp = (event)=>{
            emit('update:servicesTyp', event); // Emitujemy nową wartość do rodzica
        };
        watch(()=>__props.value, (newVal)=>{
            servicesTyp.value = newVal;
        });
        return (_ctx, _cache)=>{
            const _component_el_checkbox = _resolveComponent("el-checkbox");
            const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
            const _component_el_collapse_item = _resolveComponent("el-collapse-item");
            const _component_el_collapse = _resolveComponent("el-collapse");
            return _openBlock(), _createBlock(_component_el_collapse, {
                "model-value": _unref(width) > 768 ? [
                    '1'
                ] : '',
                class: "collapse-filter"
            }, {
                default: _withCtx(()=>[
                        _createVNode(_component_el_collapse_item, {
                            name: "1"
                        }, {
                            title: _withCtx(()=>_cache[1] || (_cache[1] = [
                                    _createElementVNode("p", {
                                        class: "display-xs"
                                    }, "Typ usługi", -1)
                                ])),
                            default: _withCtx(()=>[
                                    _createElementVNode("div", null, [
                                        _createVNode(_component_el_checkbox_group, {
                                            modelValue: _unref(servicesTyp),
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_isRef(servicesTyp) ? servicesTyp.value = $event : servicesTyp = $event),
                                            class: "w-full flex flex-col gap-[1.6rem]",
                                            onChange: updateServiceTyp
                                        }, {
                                            default: _withCtx(()=>[
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesTypList), (item)=>{
                                                        return _openBlock(), _createBlock(_component_el_checkbox, {
                                                            key: item.id,
                                                            label: item.name,
                                                            value: item.term_id,
                                                            class: "body-sm"
                                                        }, null, 8, [
                                                            "label",
                                                            "value"
                                                        ]);
                                                    }), 128))
                                                ]),
                                            _: 1
                                        }, 8, [
                                            "modelValue"
                                        ])
                                    ])
                                ]),
                            _: 1
                        })
                    ]),
                _: 1
            }, 8, [
                "model-value"
            ]);
        };
    }
};
